export default __webpack_public_path__ + "static/media/engagement2.52ea2535.png";